// Map standardized partner names to UI-friendly display format
export const PARTNER_OPTIONS = [
  { label: 'SBC', value: 'capital-one' },
  { label: 'Clover', value: 'clover' },
  { label: 'Shopify', value: 'shopify' },
  { label: 'Melio', value: 'melio' },
  { label: 'SBB', value: 'sbb' },
  { label: 'Fiserv - US Bank', value: 'fiserv_us-bank' },
  { label: 'Gusto', value: 'gusto' },
  { label: 'Paypal', value: 'paypal' },
  { label: 'Fiserv - WaFd', value: 'fiserv_wafed' },
  { label: 'ADP', value: 'adp' },
  { label: 'Wells Fargo', value: 'wells-fargo' }
];
